import { REST_POINT_BY_ID } from '../constants/graphql/restpoint';
import {TYPE_DELIVERY} from '../constants/keywords'

const orderFunc = {
  fullAddress: function (ord, type) {
    if (ord.typeDelivery !== null && ord.typeDelivery.keyword === TYPE_DELIVERY.PICKUP) { return 'Самовывоз' }
    if (!ord.street) { return 'Адрес не указан' }

    let addr = ord
    let adStr = ''

    adStr += addr.city ? `г. ${addr.city}, ` : ''
    adStr += `ул. ${addr.street}`

    if (addr.house) {
      adStr += `, д. ${addr.house}`
    }

    if (type === 'full') {
      adStr += addr.entrance ? `, под. ${addr.entrance}` : ''
      adStr += addr.floor ? ', эт. ' + addr.floor : ''
      adStr += addr.apartment ? ', кв. ' + addr.apartment : ''
      adStr += addr.office ? ', офис. ' + addr.office : ''
    }

    return adStr
  },
  stringAddress: function (ord) {
    let addr = ord
    let adStr = ''

    adStr += `${addr.street}`
    if (addr.house) {
      adStr += ` ${addr.house}`
    }
    return adStr
  },
  shortNameWorker: function (worker) {
    if (worker) {
      let parts = [
        worker.lastName ? worker.lastName : '',
        worker.firstName ? worker.firstName : '',
        worker.secondName ? worker.secondName : ''
      ]

      parts = parts.filter(_ => _)

      if (parts.length) {
        return parts.reduce(
          (text, value, i, array) => text + (i > 1 ? '. ' : ' ') + (i > 0 ? value.slice(0, 1) : value))
      } else return 'Не указано'

    } else return 'Не указано'
  },
  fullNameWorker: function (worker) {
    return `${worker.lastName} ${worker.firstName} ${worker.secondName}`
  },
  async determineRestPoint () {
    if (this.$userControl.jwtParsed) {
      let result = await this.$apollo.query({
        query: REST_POINT_BY_ID,
        fetchPolicy: 'network-only',
        variables: {
          id: this.$userControl.jwtParsed.rest_point_id
        }
      })
      let restPoints = result.data.allRestPoints.nodes

      if (restPoints.length) {
        return restPoints[0]
      }
    }
  },
  createStageKey ({ idType, keyword }) {
    return `${idType}-${keyword}`
  }
}
export default orderFunc



// WEBPACK FOOTER //
// ./src/functionsLib/orderFunc.js